import { gql } from "@apollo/client";

export const SEND_CREATE_BOOKMARK = gql`
  mutation CreateBookmark(
    $stockpileId: String!
    $requestId: String!
    $inputStockpile: String!
    $sensorId: String!
    $text: String
    $title: String!
    $archivedAt: DateTime
    $archivedBy: String
    $x: Float!
    $userInfo: UserInfoType!
  ) @api(name: "cosmos") {
    createBookmark(
      bookmark: {
        stockpileId: $stockpileId
        requestId: $requestId
        inputStockpile: $inputStockpile
        sensorId: $sensorId
        text: $text
        title: $title
        archivedAt: $archivedAt
        archivedBy: $archivedBy
        x: $x
        userInfo: $userInfo
      }
    ) {
      id
      requestId
      stockpileId
      title
      text
      x
    }
  }
`;

export const SEND_DELETE_BOOKMARK = gql`
  mutation DeleteBookmark(
    $stockpileId: String!
    $id: ID!
    $userInfo: UserInfoType!
  ) @api(name: "cosmos") {
    removeBookmark(
      bookmarkData: { stockpileId: $stockpileId, id: $id, userInfo: $userInfo }
    ) {
      id
      requestId
    }
  }
`;
